<template>
  <div class="filial-select-list-component">
    <loader v-if="loadingList">
    </loader>
    <template v-else>
      <v-text-field
        class="filial-select-list-search"
        v-model="search"
        placeholder="Поиск..."
        dense
      >
        <template v-slot:append>
          <font-awesome-icon color="#FF9100" icon="search" />
        </template>
      </v-text-field>

      <div class="filial-select-list-container" >
        <perfect-scrollbar :options="scrollbarOptions">
          <v-list class="filial-select-list" :style=" {height: `${height}px`}">
            <v-list-item
              v-ripple
              class="filial-select-list__item"
              value="1"
              v-for="filial in filteredFilials"
              :key="filial.id"
              @click="$emit('change', filial.id)"
              :class="{active: selectedFilialId===filial.id}"
            >
              <global-filial-select-item
                :item="filial"
                :is-select-value="true"
              />
            </v-list-item>
          </v-list>
        </perfect-scrollbar>
      </div>
    </template>
  </div>
</template>

<script>
  import GlobalFilialSelectItem from '@/components/header/GlobalFilialSelectItem.vue'
  import { mapGetters } from 'vuex'
  import Loader from '@/components/loader/Loader.vue'
  import FilialDataService from '@/services/api/FilialDataService'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'FilialSelectList',
    components: { Loader, GlobalFilialSelectItem },
    mixins: [snackbarMessage],
    model: {
      prop: 'selectedFilialId',
      event: 'change',
    },
    props: {
      selectedFilialId: {
        type: Number,
        default: null,
      },
      height: {
        type: Number,
        default: 400,
      },
    },
    data () {
      return {
        allFilials: [],
        loadingList: false,
        search: '',
        scrollbarOptions: {
          suppressScrollX: true,
        },
      }
    },
    created () {
      this.loadFilialsData()
    },
    watch: {

    },
    computed: {
      ...mapGetters({
        // loadingList: 'branches/getLoadingListState',
        // allFilials: 'branches/getBranches',
        globalFilialId: 'branches/getGlobalFilialId',
        globalFilialShortName: 'branches/getGlobalFilialShortName',
      }),
      filteredFilials () {
        return this.allFilials.filter((filial) => {
          return filial.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },
    },
    methods: {
      async loadFilialsData () {
        this.loadingList = true
        try {
          this.allFilials = await FilialDataService.getAll()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loadingList = false

        // await this.$store.dispatch('branches/fetchBranches')
      },
    },
  }
</script>

<style scoped lang="less">
.filial-select-list-component {

  .filial-select-list-container {
    border: 1px solid #9e9e9e;
    border-radius: 4px;
  }

  .filial-select-list {
    border-radius: 4px;

    &__item {
      transition: all 0.3s ease;
      cursor: pointer;

      ::v-deep {
        .s-filial-item__city {
          color: #696969;
        }
      }

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: rgba(255, 147, 7, 0.39); //#fefefe;

        ::v-deep {
          .s-filial-item__city {
            //color: #000;
          }
        }
      }
    }
  }

  ::v-deep {
    .ps__rail-y {
      opacity: 1 !important;
    }
  }

}

</style>
